export enum URL_PARAMS {
  LOGOUT = 'logout',
  HID = 'hid',
  TOKEN = 'token'
}

export enum PRIVATE_PAGE_ROUTES {
  USERS = '/users',
  CREATE_USER = '/users/create',
  EDIT_USER = '/users/:userId/edit',
  SINGLE_USER = '/users/:userId',
  EVENTS = '/events',
  CREATE_EVENT = '/events/create',
  EDIT_EVENT = '/events/:eventId/edit',
  SINGLE_EVENT = '/events/:eventId',
  CREATE_VIDEO = '/events/:eventId/create-video',
  CREATE_TRIBUTE_VIDEO = '/events/:eventId/create-video/:tributeVideoId',
  CREATE_COVER_PHOTOS = '/events/:eventId/cover-photos/create',
  CREATE_TEXT_OVERLAY = '/events/:eventId/text-overlay/create',
  EDIT_TEXT_OVERLAY = '/events/:eventId/text-overlay/:textOverlayId',
  CREATE_TEXT_OVERLAY_FOR_ORGANIZATION = '/organization-assets/text-overlay/create/:organizationId',
  EDIT_TEXT_OVERLAY_FOR_ORGANIZATION = '/organization-assets/text-overlay/:organizationId/edit/:textOverlayId',
  UPLOAD_COVER_PHOTO_CONTENT = '/events/:eventId/upload-content/cover-photos/create',
  EDIT_COVER_PHOTO_CONTENT = '/events/:eventId/upload-content/cover-photos/:finalAssetId/edit',
  EDIT_COVER_PHOTO = '/events/:eventId/cover-photos/:finalAssetId/edit',
  COVER_PHOTOS = '/events/:eventId/upload-content/cover-photos',
  UPLOAD_TEXT_CONTENT = '/events/:eventId/upload-content/text',
  UPLOAD_CONTENT_REQUESTS = '/events/:eventId/upload-content/requests',
  UPLOAD_CONTENT_PHOTO_VIDEO = '/events/:eventId/upload-content/photos-videos',
  UPLOAD_CONTENT_TRIBUTE_VIDEO = '/events/:eventId/upload-content/tribute-videos',
  UPLOAD_CONTENT_MUSIC = '/events/:eventId/upload-content/music',
  UPLOAD_CONTENT_CREATE_TRIBUTE_VIDEO = '/events/:eventId/upload-content/tribute-videos/create',
  UPLOAD_CONTENT_LIVE_STREAM = '/events/:eventId/upload-content/live-stream',
  UPLOAD_CONTENT_VIEW_TRIBUTE_VIDEO = '/events/:eventId/upload-content/tribute-videos/create/:tributeVideoId',
  CREATE_DEVICE = '/devices/create',
  EDIT_DEVICE = '/devices/:deviceId/edit',
  DEVICES = '/devices',
  SINGLE_DEVICE = '/devices/:deviceId',
  ADD_DEVICE = '/devices/create/addDevice',
  ORGANIZATIONS = '/organizations',
  CREATE_ORGANIZATION = '/organizations/create',
  EDIT_ORGANIZATION = '/organizations/:organizationId/edit',
  SINGLE_ORGANIZATION = '/organizations/:organizationId',
  STOCK_CLIPS = '/stock-clips',
  PROFILE = '/profile',
  THEMES = '/themes',
  SINGLE_VIDEO_THEME = '/themes/:themeId',
  CREATE_THEME = '/themes/create',
  EDIT_THEME = '/themes/:themeId/edit',
  PAYMENT_PLANS = '/payment-plans',
  SINGLE_PAYMENT_PLAN = '/payment-plans/:planId',
  CREATE_PAYMENT_PLAN = '/payment-plans/create',
  EDIT_PAYMENT_PLAN = '/payment-plans/:planId/edit',
  PLAYLISTS = '/playlists',
  SINGLE_PLAYLISTS = '/playlists/:playlistId',
  DIGITAL_SIGNAGE_PLAYLISTS = '/digital-signage/playlists',
  DIGITAL_SIGNAGE_SINGLE_PLAYLIST = '/digital-signage/playlists/:playlistId',
  DIGITAL_SIGNAGE_SCREENS = '/digital-signage/screens',
  ORGANIZATION_ASSETS = '/organization-assets',
  SETTINGS = '/settings',
  DASHBOARD = '/dashboard',
  PLAYER_RELEASES = '/player-releases',
  CREATE_PLAYER_RELEASE = '/player-releases/create',
  EDIT_PLAYER_RELEASE = '/player-releases/:playerReleaseId/edit',
  SINGLE_PLAYER_RELEASE = '/player-releases/:playerReleaseId',
  CEREMONY_TEMPLATES = '/ceremony-templates',
  CREATE_CEREMONY_TEMPLATE = '/ceremony-templates/create',
  EDIT_CEREMONY_TEMPLATE = '/ceremony-templates/:eventTemplateId/edit',
  SINGLE_CEREMONY_TEMPLATE = '/ceremony-templates/:eventTemplateId',
  MFA_SETUP = '/mfa-setup'
}

export enum PUBLIC_PAGE_ROUTES {
  STREAM = '/stream',
  LOGIN = '/login',
  SET_PASSWORD = '/setPassword',
  CHECK_EMAIL = '/checkEmail',
  SEND_EMAIL = '/sendEmail',
  MFA_VERIFY = '/mfa-verify',
  REGISTER = '/register',
  CONFIRM_EMAIL_CHANGE = '/confirmEmailChange'
}
